import React from 'react';
import { Home, Palette, FolderOpen, QrCode, HelpCircle, Settings, Download, Image as ImageIcon, MessageSquare, Mic, Play } from 'lucide-react';
export function AppMockup() {
  const voicemails = [{
    id: 1,
    name: 'Amelia Thornton',
    date: 'Jul 7, 2025',
    duration: '02:28',
    color: 'bg-card-blue'
  }, {
    id: 2,
    name: 'Julian Westbrook',
    date: 'Jul 7, 2025',
    duration: '01:23',
    color: 'bg-card-tan'
  }, {
    id: 3,
    name: 'Clara Montgomery',
    date: 'Jul 6, 2025',
    duration: '00:38',
    color: 'bg-card-olive'
  }, {
    id: 4,
    name: 'Harrison Lowell',
    date: 'Jul 6, 2025',
    duration: '01:42',
    color: 'bg-card-coral'
  }, {
    id: 5,
    name: 'Lillian Crestwood',
    date: 'Jul 6, 2025',
    duration: '02:11',
    color: 'bg-card-blue'
  }, {
    id: 6,
    name: 'Everett Kingsley',
    date: 'Jul 6, 2025',
    duration: '03:03',
    color: 'bg-card-blue'
  }, {
    id: 7,
    name: 'Rosalie Bennett',
    date: 'Jul 6, 2025',
    duration: '00:43',
    color: 'bg-card-tan'
  }, {
    id: 8,
    name: 'Dominic Harwood',
    date: 'Jul 5, 2025',
    duration: '00:45',
    color: 'bg-card-olive'
  }];
  // Helper to generate random waveform bars
  const Waveform = () => <div className="flex items-center space-x-[2px] h-8" data-id="element-14">
      {[...Array(20)].map((_, i) => <div key={i} className="w-1 bg-white/40 rounded-full" style={{
      height: `${Math.max(20, Math.random() * 100)}%`
    }} data-id="element-15" />)}
    </div>;
  return <div className="w-full max-w-5xl mx-auto bg-cream-100 rounded-2xl overflow-hidden shadow-2xl flex aspect-[16/10] transform rotate-x-12 perspective-1000" data-id="element-16">
      {/* Sidebar */}
      <div className="w-20 bg-brown-900 flex flex-col items-center py-6 space-y-8 flex-shrink-0" data-id="element-17">
        <div className="w-8 h-8 text-white font-script text-xl flex items-center justify-center" data-id="element-18">
          I
        </div>

        <div className="flex flex-col items-center space-y-6 w-full" data-id="element-19">
          <div className="p-2 text-gray-500 hover:text-white cursor-pointer transition-colors" data-id="element-20">
            <Home size={20} data-id="element-21" />
          </div>
          <div className="p-2 text-gray-500 hover:text-white cursor-pointer transition-colors" data-id="element-22">
            <Palette size={20} data-id="element-23" />
          </div>
          <div className="p-2 text-accent-pink bg-brown-800 rounded-lg w-full flex justify-center cursor-pointer border-l-2 border-accent-pink" data-id="element-24">
            <FolderOpen size={20} data-id="element-25" />
          </div>
          <div className="p-2 text-gray-500 hover:text-white cursor-pointer transition-colors" data-id="element-26">
            <QrCode size={20} data-id="element-27" />
          </div>
          <div className="p-2 text-gray-500 hover:text-white cursor-pointer transition-colors" data-id="element-28">
            <MessageSquare size={20} data-id="element-29" />
          </div>
          <div className="p-2 text-gray-500 hover:text-white cursor-pointer transition-colors" data-id="element-30">
            <HelpCircle size={20} data-id="element-31" />
          </div>
        </div>

        <div className="mt-auto p-2 text-gray-500 hover:text-white cursor-pointer transition-colors" data-id="element-32">
          <Settings size={20} data-id="element-33" />
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 flex flex-col bg-cream-100 overflow-hidden" data-id="element-34">
        {/* Header */}
        <div className="px-8 py-6 flex justify-between items-center bg-cream-100" data-id="element-35">
          <h2 className="text-2xl font-bold text-brown-900 font-serif" data-id="element-36">
            Content
          </h2>
          <button className="flex items-center space-x-2 text-xs font-bold text-brown-900 border border-brown-900/20 px-4 py-2 rounded-lg hover:bg-brown-900/5 transition-colors uppercase tracking-wider" data-id="element-37">
            <Download size={14} data-id="element-38" />
            <span data-id="element-39">Download All</span>
          </button>
        </div>

        {/* Tabs */}
        <div className="px-8 flex space-x-2 border-b border-gray-200" data-id="element-40">
          <button className="flex-1 py-3 flex items-center justify-center space-x-2 text-gray-400 text-xs font-bold uppercase tracking-wider hover:bg-gray-50 rounded-t-lg transition-colors" data-id="element-41">
            <ImageIcon size={14} data-id="element-42" />
            <span data-id="element-43">Gallery</span>
          </button>
          <button className="flex-1 py-3 flex items-center justify-center space-x-2 text-gray-400 text-xs font-bold uppercase tracking-wider hover:bg-gray-50 rounded-t-lg transition-colors" data-id="element-44">
            <MessageSquare size={14} data-id="element-45" />
            <span data-id="element-46">Messages</span>
          </button>
          <button className="flex-1 py-3 flex items-center justify-center space-x-2 text-brown-900 bg-white shadow-sm text-xs font-bold uppercase tracking-wider rounded-t-lg border-b-2 border-yellow-600" data-id="element-47">
            <Mic size={14} data-id="element-48" />
            <span data-id="element-49">Voicemails</span>
          </button>
        </div>

        {/* Content Area */}
        <div className="flex-1 p-8 overflow-y-auto bg-cream-100" data-id="element-50">
          <div className="flex justify-between items-center mb-6" data-id="element-51">
            <h3 className="text-lg font-bold text-brown-900" data-id="element-52">Voicemails</h3>
            <span className="text-xs text-gray-500" data-id="element-53">Showing 33 voicemails</span>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 gap-4" data-id="element-54">
            {voicemails.map(vm => <div key={vm.id} className="bg-white rounded-xl p-4 shadow-sm hover:shadow-md transition-shadow border border-gray-100" data-id="element-55">
                <div className={`${vm.color} rounded-lg p-4 mb-3 flex items-center space-x-3 text-white`} data-id="element-56">
                  <button className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center hover:bg-white/30 transition-colors flex-shrink-0" data-id="element-57">
                    <Play size={14} fill="currentColor" data-id="element-58" />
                  </button>
                  <div className="flex-1 overflow-hidden" data-id="element-59">
                    <Waveform data-id="element-60" />
                  </div>
                  <span className="text-xs font-medium opacity-90" data-id="element-61">
                    {vm.duration}
                  </span>
                </div>
                <div className="flex justify-between items-end px-1" data-id="element-62">
                  <div data-id="element-63">
                    <p className="text-sm font-bold text-brown-900" data-id="element-64">
                      {vm.name}
                    </p>
                    <p className="text-xs text-gray-500" data-id="element-65">{vm.date}</p>
                  </div>
                  <div className="w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-t-[8px] border-t-gray-200 transform rotate-180 opacity-0 group-hover:opacity-100" data-id="element-66"></div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </div>;
}